import { cx } from '#/Scripts/utilities/cx';

interface LabelForProps {
  name: string;
  label: string;
  hidden?: boolean;
}

export const LabelFor = ({ name, label, hidden }: LabelForProps) => {
  return (
    <label htmlFor={name} className={cx('text-label', hidden && 'hidden')}>
      {label}
    </label>
  );
};
